import apiUrl from './../../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import Paginate from 'vuejs-paginate';
//import VueElementLoading from 'vue-element-loading';
import {BasicSelect,  MultiSelect} from 'vue-search-select'
import vueMultiSelect from 'vue-multi-select';
import 'vue-multi-select/dist/lib/vue-multi-select.css';
import Utility from './../../../utility/services/utility.service';
import Loader from './../../../shared/components/loader'
import Treeselect from '@riophae/vue-treeselect';
import TripServices from './../../../firstAndLastmilemanagement/services/firstAndLastmilemanagement.service';
import CONSTANT from '../../../shared/constants/constant';

export default {
  name: 'updateInvoicedetails',
  components: {
    Treeselect,
    Paginate,
    BasicSelect,
    Utility,
    vueMultiSelect,
    TripServices,
    Loader
  },
  data: function() {
    return {
        isLoading:false,
        HubId:"",
        newsrUserList:[],
        srList:[],
        tmstripid:"",
        srUserId: null,
        newSrUserId:null,
        srUserEmail: '',
        tripStatus:"",
        userType:"",
        adHocVehicleNumber: '',
        showSRdetails:false,
        newsrUser:"",
        newsrUserEmail:"",
        newuserType:"",
        errmsg:"",
        usersrid:"",
        comments:'',
        accessdenied: false,
    }
  },
  computed: {

  },
  async mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userName = userdetail.email;
    this.userdetail = userdetail;
    this.HubName = userdetail.currentHubName;
	await this.getSRTransferUsers();
    
  },
  methods: {
    selectNewSRUser(user){
        this.newsrUser = user.srname
        this.newSrUserId = user.id
        this.newsrUserEmail = user.sremail
        this.newuserType = user.emptype
      },
  
    isIntegerOnly: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode < 48 || charCode > 57) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    async getSRListing() {
        try {
          this.isLoading = true;
          this.newsrUserList = []
          let InputPayload = {
            HubId: [this.HubId]
          };
          let result = await TripServices.getSRList(InputPayload);
          let SRListdata = await result.data.data;
          SRListdata.forEach(item=>{
            var flag; 
            if(this.usersrid == item.userid){
             flag = true;
            }else{
              flag = false;
            }         
              this.newsrUserList.push({
                id:item.userid,
                label:`${item.srname} (${item.userid})`,
                sremail:item.email,
                srname:item.srname,
                emptype:item.emptype,
                isDisabled: (item.disable || flag)
              })
            })
            this.isLoading = false;
        } catch (err) {
          console.log(err);
        }
      },
      checkErr(){
        let err = 0
        if(!this.tmstripid){
          this.errmsg = 'Please Enter TMS Trip Id'
          err = 1
        }else{
          this.errmsg = ''
        }
        return err
      },
      async getSRDetailsdata() {
        try {
          if(this.checkErr()){
            return false
          }
            this.isLoading = true;
            let InputPayload = {
              tmstripid: this.tmstripid
            };
       
            let result = await Utility.getSRdetails(InputPayload);
            if(result.data.data != null){
              this.HubId = result.data.data.hubid
              if(result.data.data.tripstatus != 'closed'){
                this.showSRdetails = true
                this.usersrid = result.data.data.userid;
                this.isLoading = false;
                let matchresult = result.data.data.username.includes("(");
                if(matchresult == true){
                  this.srUserId = result.data.data.username
                }else{
                  this.srUserId = `${result.data.data.username} (${result.data.data.userid})`
                }
                this.getSRListing()
                this.userType = result.data.data.usertype
                this.adHocVehicleNumber = result.data.data.vehiclenumber
              }else{
                this.isLoading = false;
                this.showSRdetails = false
                this.$alert("Trip already closed. You can't change SR", "", "error");
              }
             
            }else{
              this.showSRdetails = false;
              this.isLoading = false;
              this.$alert("Trip Id Not Found", "", "error");
            }
          
        } catch (err) {
          console.log(err);
        }
      },

    reset() {
      this.tmstripid = '';
      this.srUserId = null;
      this.newSrUserId = null;
      this.showSRdetails = false;
      this.adHocVehicleNumber = "";
      this.userType = "",
      this.comments = ''
      this.$validator.reset();

    },
    async updateSRDetails(){
      try{
            this.isLoading=true;
            let payload = {
              "tmstripid":this.tmstripid,
              "sruserid":this.newSrUserId,
              "srusername": this.newsrUser,
              "srusertype": this.newuserType,
              "sruseremail":this.newsrUserEmail,
              "updatedby":this.userName,
              "comments":this.comments,
              "oldsruserid":this.usersrid
            }
            let result = await Utility.updateTripSR(payload);
            console.log("result",result)
            if(result.data.code == 200){
              this.$alert(result.data.message, "", "success");
            }else{
              this.$alert(result.data.message, "", "error");
            }
             this.isLoading=false;
             this.reset();
          }
      catch(err){
        this.$alert(err,"","error");
      }
    },
	async getSRTransferUsers(){
		this.isLoading=true;
		let payload ={
			key:'SRTRANSFER'
		}
		let result = await Utility.getSRTransferUserDetails(payload);
		if(result.data.code == 200){
			let users = result.data.data[0].value;
			if(!users.includes(this.userName.toLowerCase())){
				this.accessdenied=true
			}
		}else{
			this.$alert(result.data.message, "", "error");
		}
		this.isLoading=false;
	},
    onSubmit: function(event) {
      this.$validator.validateAll().then(async(result) => {
        if (result) {
          let result = await this.showPodPendencyWarning()
          this.checkRestrictionErr('create')
          // this.updateSRDetails();
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    async showPodPendencyWarning() {
      let inputPayload = {
        hubid: [this.HubId],
        userid:parseInt(this.newSrUserId)
      }
      let podPendencyData = await TripServices.fetchSrPodPendancyDetails(inputPayload)
      if (podPendencyData && podPendencyData.data.code != 200) {
        if (podPendencyData && podPendencyData.data.code == 201) {
          this.visibleWarningMessage = true
          this.podPendencyWarningMessage = podPendencyData.data.data.webmessage
          this.restrictSrFromTripCreation = false
          
        } else if(podPendencyData && podPendencyData.data.code == 204) {
          this.visibleWarningMessage = false
          this.podPendencyWarningMessage = podPendencyData.data.data.webmessage
          this.restrictSrFromTripCreation = true
        } else {
          this.restrictSrFromTripCreation = false
          this.visibleWarningMessage = false
        }
      } else {
        this.restrictSrFromTripCreation = false
        this.podPendencyWarningMessage=""
          this.visibleWarningMessage = false
      }
      
    },
    async checkRestrictionErr(tripStatus) {  
       let err = 0  
       await this.showPodPendencyWarning()
      if (this.visibleWarningMessage) { 
         let messageString = `
        <br><i class="fa fa-exclamation-circle fa-4x" aria-hidden="true" style="color: #5490e9;"></i><br><br>
         <p style="font-size:18px">${this.podPendencyWarningMessage}</p>         
         `
           this.$fire({
             icon: "success",
              html: messageString,
              width: 500,
              textalign: 'center',
              reverseButtons: true,
              showCancelButton: true,
              cancelButtonColor: '#20a8d8',
              confirmButtonColor: '#009C41',
              confirmButtonText: '<i class="fa fa-thumbs-up"></i> View Pendency List',
              cancelButtonText: '<i class="fa fa-times-circle-o"></i> Close',         
           }).then((result) => {
                if (result.value == true) {
					let query = {
						userid : this.newSrUserId
					}
					const queryString = new URLSearchParams(query).toString();
					const url = `#/poduploadpendency?${queryString}`;
					window.open(url, '_blank');
                } else {
                  if (tripStatus == 'create') {
                  this.updateSRDetails()
                  }
                  if (tripStatus == 'start') {
                    this.ShowStartTrip()
                  }
                 }
              }).catch((err)=>{
               console.log(err)
             });
         err = 0
       }else if (this.restrictSrFromTripCreation) {
         let messageString = `
        <br><i class="fa fa-times-circle fa-4x" aria-hidden="true" style="color: #ef2814;"></i><br><br>
         <p style="font-size:18px">You cannot change SR because there are pending PODs (Proof of Delivery) that need to be uploaded. Please upload all pending PODs to proceed with the SR change.</p> 
         `
           this.$fire({
             icon: "success",
              html: messageString,
              width: 500,
              textalign: 'center',          
              reverseButtons: true,
              showCancelButton: true,
              cancelButtonColor: '#20a8d8',
              confirmButtonColor: '#009C41',
              confirmButtonText: '<i class="fa fa-thumbs-up"></i> View Pendency List',
              cancelButtonText: '<i class="fa fa-times-circle-o"></i> Close',         
              }).then((result) => {
                if (result.value == true) {
					let query = {
						userid : this.newSrUserId
					}
					const queryString = new URLSearchParams(query).toString();
					const url = `#/poduploadpendency?${queryString}`;
					window.open(url, '_blank');
                 }
              }).catch((err)=>{
               console.log(err)
             }); 
         err = 1
       } else {
         if (tripStatus == 'create') {
           this.updateSRDetails()
           }
           if (tripStatus == 'start') {
             this.ShowStartTrip()
           }
       }
       return err
     },
  }
}



// WEBPACK FOOTER //
// ./src/modules/utility/views/changeassignedsr/changeassignedsr.component.js